/* eslint-disable no-unused-vars */
import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button, Card, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import * as Yup from 'yup';
import { ReactComponent as TrashIcon } from '../assets/svg/remove.svg';
import { ReactComponent as EditIcon } from '../assets/svg/edit.svg';
import { ReactComponent as SearchIcon } from '../assets/svg/search.svg';
import { ReactComponent as EyeIcon } from '../assets/svg/eye-off-outline.svg';
import { ReactComponent as EyeOffIcon } from '../assets/svg/eye-outline.svg';
import noUser from '../assets/img/no_user.jpg';
import TableComponent from '../comman/component/table';
import MyDropZone from '../comman/component/uploadfile.component';
import { useDebounce } from '../helper/comman';
import Select from 'react-select';
import {
  setModalAction,
  setShowModal,
} from '../redux/active-tabs/active-tab.action';
import { showToast } from '../redux/auth/auth.action';
import {
  createUser,
  deleteUser,
  getUserImage,
  searchUserProfile,
  searchUsers,
  updateUser,
  updateUserImage,
} from '../services/user';
import { formatPhoneDisplay } from '../helper/phone';
import useExportData from 'hooks/useExportData';
import FooterEnd from 'comman/component/footerEnd';

const fetchUsers = async (data) => {
  const response = await searchUsers(data);
  return response;
};

const Users = ({
  setToaster,
  showModal,
  setShowModal,
  setModalAction,
  modalAction,
  userRole,
}) => {
  const columns = [
    {
      name: 'First Name',
      selector: (row) => row['firstName'],
      sortable: true,
      sortFunction: (rowA, rowB, cId) => {
        return rowA.firstName.localeCompare(rowB.firstName);
      },
      key: 'firstName',
    },
    {
      name: 'Last Name',
      selector: (row) => row['lastName'],
      sortable: true,
      sortFunction: (rowA, rowB, cId) => {
        return rowA.lastName.localeCompare(rowB.lastName);
      },
      key: 'lastName',
    },
    {
      name: 'Email Address',
      selector: (row) => row['username'],
      sortable: true,
      sortFunction: (rowA, rowB, cId) => {
        return rowA.username.localeCompare(rowB.username);
      },
      key: 'username',
    },
    {
      name: 'Phone Number',
      selector: (row) =>
        row['phone'] ? formatPhoneDisplay(row['phone']) : '-',
      sortable: true,
      key: 'phone',
      formatValue: (value) => (value ? formatPhoneDisplay(value) : '-'),
    },
    {
      name: 'Avatar',
      cell: (row) => {
        return (
          <img
            className='table-user-img'
            src={usersImages && usersImages[row['_id']]}
            alt=''
          />
        );
      },
      preventExport: true,
      // sortable: true,
    },
    {
      name: 'Edit User',
      button: true,
      omit: userRole && userRole !== 'Administrator' && true,
      preventExport: true,

      cell: (row) => {
        return (
          <div>
            <button
              className='btn btn-sm'
              style={{ marginRight: '5px' }}
              onClick={() => {
                setModalAction('edit');
                setEditInitialValues((prevState) => ({
                  ...prevState,
                  id: row._id,
                  username: row.username,
                  firstName: row.firstName,
                  lastName: row.lastName,
                  phone: row.phone,
                  userProfileId: row.userProfileId,
                }));
                setPreviewScreen((prevState) => ({
                  ...initialPreviewScreen,
                  username: row.username,
                  firstName: row.firstName,
                  lastName: row.lastName,
                  phone: row.phone,
                }));
                setShowModal(true);
              }}>
              <EditIcon />
            </button>
          </div>
        );
      },
    },
    {
      name: 'Delete User',
      button: true,
      omit: userRole && userRole !== 'Administrator' && true,
      preventExport: true,

      cell: (row) => {
        return (
          <div>
            <button
              className='btn text-danger btn-sm'
              onClick={() => deleteUserData(row._id)}>
              <TrashIcon />
            </button>
          </div>
        );
      },
    },
  ];

  const { handleExport } = useExportData({
    filename: 'contact',
    columns,
  });

  const [showHidePassword, setShowHidePassword] = useState(false);
  const [showHideConfirmPassword, setShowHideConfirmPassword] = useState(false);
  const [buttonEvent, setButtonEvent] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [profileImage, setProfileImage] = useState([]);
  const [usersImages, setUsersImages] = useState({});
  const [userProfileData, setUserProfileData] = useState();
  const [profile, setProfile] = useState([]);
  const [blobURL, setBlobURL] = useState({
    previous: '',
    current: '',
    next: '',
  });

  const initialPreviewScreen = {
    firstName: '',
    lastName: '',
    username: '',
    phone: '',
    image: noUser,
  };

  const [previewScreen, setPreviewScreen] = useState(initialPreviewScreen);
  const initialValues = {
    username: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: '',
    userProfileId: '',
  };
  const [editInitialValues, setEditInitialValues] = useState({
    id: '',
    username: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: '',
    userProfileId: '',
  });

  const [searchText, setSearchText] = useState(() =>
    window.sessionStorage.getItem('user_search_text')
  );

  const handleClose = () => {
    setShowModal(false);
    setEditInitialValues({
      id: '',
      username: '',
      password: '',
      firstName: '',
      lastName: '',
      phone: '',
      userProfileId: '',
    });
    setPreviewScreen(initialPreviewScreen);
  };

  async function fetchData() {
    const data = { q: '*' };
    const res = await fetchUsers(data);
    if (res.status === 200) {
      // setUsersData(res.data.objects);
      res.data.objects.map(async (item) => {
        if (item.avatar) {
          const resImg = await getUserImage(item._id);
          if (resImg.status === 200) {
            let base64ImageString = Buffer.from(resImg.data, 'binary').toString(
              'base64'
            );
            setUsersImages((prevState) => ({
              ...prevState,
              [item._id]: 'data:image/jpeg;base64,' + base64ImageString,
            }));
          } else {
            setUsersImages((prevState) => ({
              ...prevState,
              [item._id]: noUser,
            }));
          }
        } else {
          setUsersImages((prevState) => ({
            ...prevState,
            [item._id]: noUser,
          }));
        }
      });
    }
  }

  useEffect(() => {
    fetchData();
    searchData(searchText);
    setShowModal(false);
    getUserProfileData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function searchData(value) {
    const data = { q: value };
    const res = await fetchUsers(data);
    if (res.status === 200) {
      if (res.data.total > 0) {
        setUsersData(res.data.objects);
      } else {
        setUsersData([]);
      }
    }
  }

  const search = useDebounce(searchData, 500);

  const getUserProfileData = async () => {
    const data = { q: '*' };
    const res = await searchUserProfile(data);
    const userProfile = [];
    if (res.status === 200) {
      res.data.objects.forEach((profile) => {
        userProfile.push({
          value: profile._id,
          label: profile.name,
        });
      });
      setUserProfileData(userProfile);
    }
  };

  const validationSchema = Yup.object().shape(
    {
      username: Yup.string().required('Username is required'),
      password: Yup.string().required('Password is required'),
      firstName: Yup.string().required('FirstName is required'),
      lastName: Yup.string().required('LastName is required'),
      userProfileId: Yup.string().required('User profile is required'),
      confirmPassword: Yup.string().when('password', (password) => {
        if (password)
          return Yup.string()
            .required('Confirm password required')
            .oneOf([Yup.ref('password'), null], 'Passwords must match');
      }),
    },
    [['confirmPassword', 'password']]
  );

  const editValidationSchema = Yup.object().shape(
    {
      username: Yup.string().required('Username is required'),
      firstName: Yup.string().required('FirstName is required'),
      lastName: Yup.string().required('LastName is required'),
      confirmPassword: Yup.string().when('password', (password) => {
        if (password)
          return Yup.string()
            .required('Confirm password required')
            .oneOf([Yup.ref('password'), null], 'Passwords must match');
      }),
      password: Yup.string().when('confirmPassword', (confirmPassword) => {
        if (confirmPassword) return Yup.string().required('Password required');
      }),
    },
    [['confirmPassword', 'password']]
  );

  const submitFunction = async (value) => {
    setButtonEvent(true);
    if (modalAction === 'add') {
      const response = await createUser(value);
      if (response.status === 201) {
        const data = {
          show: true,
          message: 'User Successfully Created',
        };
        setToaster(data);
        setUsersData((prevState) => [...prevState, response.data]);
        setModalAction(null);
        if (profileImage.length) {
          const fileName = profileImage[0].name;
          const formData = new FormData();
          formData.append(
            'fieldModifiers',
            JSON.stringify({ avatar: fileName })
          );

          let demo = await fetch(blobURL.next).then((r) => r.blob());

          formData.append('file', demo, fileName);

          const res = await updateUserImage(response.data._id, formData);
          if (res.status === 200) {
            const tempUserImages = { ...usersImages };
            tempUserImages[res.data._id] = blobURL.next;
            setUsersImages(tempUserImages);
            setProfileImage([]);
          }
        }
      }
      setShowModal(false);
      handleClose();
    } else {
      const userId = value.id;
      delete value.id;
      if (value.password === '') {
        delete value.password;
      }
      const response = await updateUser(userId, value);
      if (response.status === 200) {
        const tempUserData = [...usersData];
        const indexData = tempUserData.findIndex(
          (item) => item._id === response.data._id
        );
        tempUserData[indexData] = response.data;
        setUsersData(tempUserData);
        setModalAction(null);
        if (profileImage.length) {
          const fileName = profileImage[0].name;
          const formData = new FormData();
          formData.append(
            'fieldModifiers',
            JSON.stringify({ avatar: fileName })
          );

          let demo = await fetch(blobURL.next).then((r) => r.blob());

          formData.append('file', demo, fileName);
          const res = await updateUserImage(userId, formData);
          if (res.status === 200) {
            const tempUserImages = { ...usersImages };
            tempUserImages[res.data._id] = blobURL.next;
            setUsersImages(tempUserImages);
            setProfileImage([]);
          }
        }
      }
      setShowModal(false);
      handleClose();
    }
    setButtonEvent(false);
  };

  const uploadUserImage = async (fileData) => {
    // setShowImageEditor(true);
    setProfileImage(fileData);
    setBlobURL({
      previous: fileData[0].preview,
      current: fileData[0].preview,
      next: fileData[0].preview,
    });
  };

  const deleteUserData = async (userId) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML =
      '<p class="swal-text-data">Are you sure you want to delete this user?</p> ' +
      '<p class="swal-text-data">Deleting a user is a permanent action. Once removed it cannot be restored or modified</p>';
    swal({
      title: 'Delete Confirmation',
      content: wrapper,
      buttons: {
        confirm: {
          width: 30,
          text: 'Delete',
          value: 'delete',
          visible: true,
          className: 'swal-delete-button',
          closeModal: true,
        },
        cancel: {
          width: 15,
          text: 'Cancel',
          value: 'cancel',
          visible: true,
          className: 'swal-cancel-button',
          closeModal: true,
        },
      },
    }).then((willDelete) => {
      if (willDelete === 'delete') {
        deleteUser(userId).then((res) => {
          if (res.status === 204) {
            const tempUsersData = [...usersData];
            const updatedUsersData = tempUsersData.filter(
              (item) => item._id !== userId
            );
            setUsersData(updatedUsersData);
          }
        });
      }
    });
  };

  useEffect(() => {
    window.sessionStorage.setItem('user_search_text', searchText || '');
  }, [searchText]);

  // remove tab index for Add text in image editor

  if (document.getElementsByClassName('photo-edit-modal')[0]) {
    document
      .getElementsByClassName('photo-edit-modal')[0]
      .removeAttribute('tabindex');
  }

  return (
    <div id='pageWrapper'>
      <div className='main-page'>
        <div className='page-wrapper'>
          <div className='header-topbar justify-content-between'></div>
          <section className='common-sec users-sec card-body-no-padding'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-12'>
                  <Card>
                    <Card.Header>
                      <div className='card-header-inner'>
                        <div className='card-header-inner-left'>
                          <h2>Users</h2>
                        </div>
                        {userRole && userRole === 'Administrator' && (
                          <div className='card-header-inner-right'>
                            <div className='contact-title'>
                              <Button
                                className='btn-sm notify-mobile-btn'
                                variant='primary'
                                onClick={() => handleExport(usersData)}>
                                <i className='fas fa-file-export'></i> Export
                              </Button>

                              <Button
                                className='btn-sm'
                                variant='primary'
                                onClick={() => {
                                  setModalAction('add');
                                  setPreviewScreen({
                                    firstName: '',
                                    lastName: '',
                                    username: '',
                                    phone: '',
                                    image: noUser,
                                  });
                                  setShowModal(true);
                                }}>
                                <i className='fas fa-plus'></i> Add
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <div className='contact-wrap'>
                        <div className='container-fluid'>
                          <div className='row'>
                            <div className='col-12 col-md-12 col-lg-6'>
                              <div className='contact-filter mb-3'>
                                <div className='input-group'>
                                  <input
                                    className='form-control'
                                    type='text'
                                    name='search'
                                    placeholder='Search'
                                    value={searchText}
                                    onChange={(e) => {
                                      setSearchText(e.target.value);
                                      search(e.target.value);
                                    }}

                                    // onChange={(e) => search(e.target.value)}
                                  />
                                  {searchText && (
                                    <svg
                                      onClick={() => {
                                        setSearchText('');
                                        searchData('');
                                      }}
                                      className='close-icon'
                                      xmlns='http://www.w3.org/2000/svg'
                                      width='30'
                                      height='30'
                                      viewBox='0 0 21 21'>
                                      <path
                                        fill='none'
                                        stroke='currentColor'
                                        stroke-linecap='round'
                                        stroke-linejoin='round'
                                        d='m7.5 7.5l6 6m0-6l-6 6'
                                      />
                                    </svg>
                                  )}
                                  {/* <button className='btn btn-outline-primary'>
                                    <SearchIcon />
                                  </button> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className='user-data common-data-table'>
                            <TableComponent
                              // title='Users'
                              columns={columns}
                              data={usersData}
                            />
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
                {modalAction && (
                  <Modal
                    size='md'
                    show={showModal}
                    onHide={handleClose}
                    className='user-update-modal'
                    backdrop='static'>
                    <Modal.Header closeButton>
                      <Modal.Title>
                        {modalAction === 'add' ? (
                          <h2>Add User</h2>
                        ) : (
                          <h2>Edit User</h2>
                        )}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className='row'>
                        <div className='col-12 col-lg-12 col-md-12 col-sm-12'>
                          <div className='edit-detail-inner'>
                            <div className='user-image'>
                              <MyDropZone
                                uploadUserImage={uploadUserImage}
                                setPreviewScreen={setPreviewScreen}
                                itemId={
                                  modalAction === 'edit'
                                    ? editInitialValues.id
                                    : ''
                                }
                                profile={profile}
                                setProfile={setProfile}
                                member='user'
                                previewScreen={previewScreen}
                              />
                            </div>
                            <div>
                              <Formik
                                enableReinitialize={true}
                                initialValues={
                                  modalAction === 'add'
                                    ? initialValues
                                    : editInitialValues
                                }
                                validationSchema={
                                  modalAction === 'add'
                                    ? validationSchema
                                    : editValidationSchema
                                }
                                onSubmit={(value, { resetForm }) => {
                                  submitFunction(value);
                                  // resetForm({ values: '' });
                                }}>
                                {({
                                  values,
                                  errors,
                                  isValid,
                                  setFieldValue,
                                }) => (
                                  <Form>
                                    <div>
                                      {modalAction === 'add' ? null : (
                                        <Field type='hidden' name='id' />
                                      )}
                                      <div className='user-modal-filed-wrapper'>
                                        <div className='row'>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='form-group'>
                                              <Select
                                                name='userProfileId'
                                                className='basic-multi-select'
                                                classNamePrefix='select'
                                                options={userProfileData}
                                                value={
                                                  userProfileData &&
                                                  userProfileData.filter(
                                                    (e) =>
                                                      e.value ===
                                                      values.userProfileId
                                                  )
                                                }
                                                onChange={(opt) => {
                                                  setFieldValue(
                                                    'userProfileId',
                                                    opt.value
                                                  );
                                                }}
                                              />
                                              <ErrorMessage name='userProfileId'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div>
                                          </div>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='form-group'>
                                              <Field
                                                className='form-control'
                                                type='text'
                                                name='firstName'
                                                placeholder='First Name'
                                                onChange={(e) => {
                                                  setPreviewScreen(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      firstName: e.target.value,
                                                    })
                                                  );
                                                  setFieldValue(
                                                    'firstName',
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                              <ErrorMessage name='firstName'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div>
                                          </div>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='form-group'>
                                              <Field
                                                className='form-control'
                                                type='text'
                                                name='lastName'
                                                placeholder='Last Name'
                                                onChange={(e) => {
                                                  setPreviewScreen(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      lastName: e.target.value,
                                                    })
                                                  );
                                                  setFieldValue(
                                                    'lastName',
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                              <ErrorMessage name='lastName'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div>
                                          </div>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='form-group'>
                                              <Field
                                                className='form-control'
                                                type='text'
                                                name='phone'
                                                placeholder='Enter Number'
                                                onChange={(e) => {
                                                  setPreviewScreen(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      phone: e.target.value,
                                                    })
                                                  );
                                                  setFieldValue(
                                                    'phone',
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                              <ErrorMessage name='phone'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div>
                                          </div>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='form-group'>
                                              <Field
                                                className='form-control'
                                                type='text'
                                                name='username'
                                                placeholder='User Name'
                                                onChange={(e) => {
                                                  setPreviewScreen(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      username: e.target.value,
                                                    })
                                                  );
                                                  setFieldValue(
                                                    'username',
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                              <ErrorMessage name='username'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div>
                                          </div>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='form-group passwordHS'>
                                              <Field
                                                className='form-control'
                                                type={
                                                  showHidePassword
                                                    ? 'text'
                                                    : 'password'
                                                }
                                                name='password'
                                                placeholder={
                                                  modalAction === 'add'
                                                    ? 'Password'
                                                    : 'New password'
                                                }
                                              />
                                              <i
                                                onClick={() =>
                                                  setShowHidePassword(
                                                    !showHidePassword
                                                  )
                                                }>
                                                {showHidePassword ? (
                                                  <EyeIcon />
                                                ) : (
                                                  <EyeOffIcon />
                                                )}
                                              </i>
                                              <ErrorMessage name='password'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div>
                                          </div>
                                          <div className='col-12 col-md-12 col-lg-12'>
                                            <div className='form-group passwordHS'>
                                              <Field
                                                className='form-control'
                                                type={
                                                  showHideConfirmPassword
                                                    ? 'text'
                                                    : 'password'
                                                }
                                                name='confirmPassword'
                                                placeholder='Confirm password'
                                              />
                                              <i
                                                onClick={() =>
                                                  setShowHideConfirmPassword(
                                                    !showHideConfirmPassword
                                                  )
                                                }>
                                                {showHideConfirmPassword ? (
                                                  <EyeIcon />
                                                ) : (
                                                  <EyeOffIcon />
                                                )}
                                              </i>
                                              <ErrorMessage name='confirmPassword'>
                                                {(msg) => (
                                                  <span
                                                    className='fm_error'
                                                    style={{ color: 'red' }}>
                                                    {msg}
                                                  </span>
                                                )}
                                              </ErrorMessage>
                                            </div>
                                            {modalAction === 'add' ? (
                                              <div className='text-end'>
                                                <button
                                                  type='submit'
                                                  className='btn btn-primary'>
                                                  Add
                                                </button>
                                              </div>
                                            ) : (
                                              <div className='text-end'>
                                                <button
                                                  type='submit'
                                                  className='btn btn-primary'>
                                                  Save
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Form>
                                )}
                              </Formik>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
      <FooterEnd />
    </div>
  );
};

const mapStateToProps = ({
  activeTabReducer: { showModal, modalAction },
  authReducer: { userRole },
}) => ({
  showModal: showModal,
  modalAction: modalAction,
  userRole: userRole,
});

const mapDispatchToProps = (dispatch) => ({
  setToaster: (data) => dispatch(showToast(data)),
  setShowModal: (data) => dispatch(setShowModal(data)),
  setModalAction: (data) => dispatch(setModalAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Users);
